import * as _ from 'lodash';
import React, { useState, useContext, useEffect } from 'react';
import { useFetch } from 'use-http';
import { IAppContextState } from 'src/reducers/AppContext';
import Panel from 'src/components/common/Panel';
// import Checkbox from 'src/components/controls/forms/Checkbox';
import { AppContext } from 'src/providers/AppContextProvider';
import PagedResultSet from 'src/models/common/PagedResultSet';
import Tag from 'src/models/Tag';
import './styles/search-panel-styles.css';
import PagedItemList from './PagedItemList';
import { ODataOptions, ODataFilter, ODataOrderByDirection, ODataFilterOperators } from 'src/util/ODataBuilder';
import * as Constants from 'src/components/common/Constants';
import SearchListData from 'src/models/SearchListData';
import { DialogContext, dialogCreators } from 'src/providers/DialogProvider';
import Button from 'src/components/controls/forms/redesign/FormButton';
import { ITableConfig } from 'src/components/common/table';
import RHFInputBox from 'src/components/controls/tempRHFControls/RHFInputBox';
import { useForm } from 'react-hook-form';

interface ISearchPanelProps {
    updateFilterString: (filterString: Array<SearchListData>) => void;
    updateTags?: boolean;
    filterTownshipsCallback?: (filterTownships: boolean) => void;
    filterTractsCallback?: (filterTracts: boolean) => void;
}

const SearchPanel: React.FC<ISearchPanelProps> = (props) => {
    const { get, response } = useFetch();
    // const [isTagFilterChecked, setIsTagFilterChecked] = useState(true);
    // const [isTownshipTagFilterChecked, setIsTownshipTagFilterChecked] = useState(false);
    // const [isSectionTagFilterChecked, setIsSectionTagFilterChecked] = useState(false);
    const [isTagDataLoading, setIsTagDataLoading] = useState(false);
    const appContext = useContext<IAppContextState>(AppContext);
    const [tags, setTags] = useState<PagedResultSet<Tag>>(undefined);
    const [tagStates, setTagStates] = useState<Array<SearchListData>>([]);
    // const [tagsFilterString, setTagsFilterString] = useState<string>(undefined);
    const [tagsPagingDataOptions, setTagsPagingDataOptions] = useState<ODataOptions>(undefined);
    const [endOfList, setEndOfList] = useState<boolean>(false);
    const dialogContext = useContext<dialogCreators>(DialogContext);
    const [projectTagsSearchTerm, setProjectTagsSearchTerm] = useState(undefined);
    const { register, getValues } = useForm();

    useEffect(() => {
        setTagStates([]);
        resetDataOptions();
    }, []);

    useEffect(() => {
        reloadTags();
    }, [props.updateTags]);

    useEffect(() => {
        setIsTagDataLoading(false);
        updateTagStates();
    }, [tags]);

    useEffect(() => {
        if (tagStates?.length > 0) {
            props.updateFilterString(tagStates);
            const tagListDivElement = document.getElementById(`tagListScrollingContainer`);
            if (!!tagListDivElement) {
                tagListDivElement.scrollTop = 0;
            }
        }
    }, [tagStates]);
    
    useEffect(() => {
        if (!isTagDataLoading && tagsPagingDataOptions) {
            if (!!projectTagsSearchTerm && projectTagsSearchTerm.length > 0) {
                tagsPagingDataOptions?.addFilter(new ODataFilter('Tag.Name', ODataFilterOperators.Contains, projectTagsSearchTerm));
            }
            let isNextPage = tagsPagingDataOptions.getIsNextPage();
            getTags(tagsPagingDataOptions, isNextPage);
        }
        
    }, [tagsPagingDataOptions]);

    useEffect(() => {
        if (!!projectTagsSearchTerm || projectTagsSearchTerm === '') {
            resetDataOptions();
        }
    }, [projectTagsSearchTerm]);

    useEffect(() => {
        if (tagsPagingDataOptions?.getPageNumber() * tagsPagingDataOptions?.getPageSize() >= tags?.totalRecords) {
            setEndOfList(true);
        }
    }, [tagsPagingDataOptions, tags]);

    const resetDataOptions = () => {
        const tableConfig: ITableConfig = {
            rowCount: 100,
            idField: 'id',
            pageNumber: 1,
            columns: []
        };
        let newDataOptions = ODataOptions.from(tableConfig);
        newDataOptions.clearFilters();
        newDataOptions.addOrderBy('Name', ODataOrderByDirection.Ascending);
        setTagsPagingDataOptions(newDataOptions);
    };

    const reloadTags = () => {
        // setIsTownshipTagFilterChecked(false);
        // setIsTagFilterChecked(true);
        setTags(undefined);
        setTagStates([]);
        resetDataOptions();
    };

    const handleNewTag = () => {
        console.log('new tag');
        dialogContext.project.addUpdateProjectTags(
            'edit', reloadTags);
    };
/*
    const handleTractTagFilterChanged = () => {
        let isTrctFilterChecked = !isTagFilterChecked;
        setIsTagFilterChecked(!isTagFilterChecked);
        props.filterTractsCallback(isTrctFilterChecked);
    };

    const handleTownshipTagFilterChanged = () => {
        let isTsFilterChecked = !isTownshipTagFilterChecked;
        setIsTownshipTagFilterChecked(isTsFilterChecked);
        props.filterTownshipsCallback(isTsFilterChecked);
    };

    const handleSectionTagFilterChanged = () => {
        setIsSectionTagFilterChecked(!isSectionTagFilterChecked);
    };
*/

    const incrementTagList = () => {
        if (!endOfList) { 
            let newPagingOptions = _.cloneDeep(tagsPagingDataOptions);   
            newPagingOptions?.incrementPageNumber();
            newPagingOptions.setIsNextpage(true);
            setTagsPagingDataOptions(newPagingOptions);
        }
    };

    const resetTagsListPaging = () => {
        console.log('resetTagsListPaging called');
    };

    const updateTagsFilterString = (index: number) => {
        // if (isTagFilterChecked) {
        //     setTagsFilterString(tagStates[index].tag.name);
        // }
        let newTagStates = _.cloneDeep(tagStates);
        newTagStates[index].state = !newTagStates[index].state;
        newTagStates.sort((a, b) => (a.state === b.state) ? 0 : (a.state ? -1 : 1));
        setTagStates(newTagStates);
    };

    const displayTagSearchResults = () => {
        if (tagStates) {
            // return tags?.items.map((listTag: Tag, listIndex: number) => {
            return tagStates && tagStates?.map((ts: SearchListData, listIndex: number) => {
                return (
                    <div key={listIndex}>
                        <label key={listIndex}>
                            <input
                                type="checkbox"
                                checked={ts?.state}
                                value={listIndex}
                                onChange={(e: React.ChangeEvent<HTMLInputElement>) => updateTagsFilterString(Number(e.target.value))}
                            />
                        {ts.tag.name}
                        </label>
                    </div>
                );
            });
        } else if (isTagDataLoading) {
            return <div>Loading...</div>;
        } else {
            return <div>No Tags Found</div>;
        }
    };

    const getScrollStatus = (divElement: HTMLDivElement) => {
        if (divElement) {
            const scrollTop = divElement.scrollTop % 1 > .9 ? divElement.scrollTop : Math.round(divElement.scrollTop);
            const scrollHeight = divElement.scrollHeight;
            const clientHeight = divElement.clientHeight;

            // Check if reached the end of the list
            if (scrollTop + clientHeight >= scrollHeight - 5/*This is because I've seen it be just +1 difference*/) {
                incrementTagList();
                console.log('end of scroll YES');
            } else {
                console.log('end of scroll NO');
            }
        }
    };

    const tagsSearch = _.debounce(() => {
        let searchName = getValues()?.projectTagSearch;
        setProjectTagsSearchTerm(searchName);
    }, 800);

    const onTagSearchChanged = (searchContent: string) => {
        console.log(searchContent);
        tagsSearch();
    };

    const updateTagStates = () => {
        let newTagStates = new Array<SearchListData>();
        tags?.items.map((tag: Tag, index: number) => {
            let state: boolean | undefined = (tagStates.find((ts) => ts.tag.name === tag.name)?.state);
            let newTagState = new SearchListData();
            newTagState.tag = tag;
            newTagState.index = index;
            newTagState.state = (!!state ? state : false);
            newTagStates.push(newTagState);
        });
        newTagStates.sort((a, b) => (a.state === b.state) ? 0 : (a.state ? -1 : 1));
        setTagStates(newTagStates);
    };

    const getTags = async (dataOptions: ODataOptions, nextPage: boolean) => {
        setIsTagDataLoading(true);
        const result = await get(`v1.0/clients/${appContext.clientNumber}/projects/${appContext.projectNumber}/tags${dataOptions.toString()}`);
        if (response.ok) {
            if (nextPage === true) {
                let tempResult = _.cloneDeep(tags);
                tempResult.pageNumber += 1;
                tempResult.items = [...tempResult?.items].concat([...(result?.items !== undefined ? result.items : [])]);
                setTags(tempResult);
/*                 result?.items.map((listTag: Tag, listIndex: number) => {
                    tagStates.push({ index: listIndex, state: false, tag: listTag });
                });
                setTagStates(tagStates); */
            } else {                
                setTags(result);
/*                 result?.items.map((listTag: Tag, listIndex: number) => {
                    tagStates.push({ index: listIndex, state: false, tag: listTag });
                });
                setTagStates(tagStates); */
            }
        } else {
            console.log('bad request', response);
        }
    };

    return (
        <>
            <div>
                <Panel fitPanelToScreen={false}>
                    <div>
                        <div>
                            <h2
                                className="tag-filter-title"
                                style={{ textAlign: 'center' }}
                            >
                                Tag Filter Options
                            </h2>
                        </div>
                        <div>
                            <hr/>
                        </div>
                        <div>
                            <h4>Project Tags</h4>
                            </div>
                            <div>
                                <label style={{paddingRight: '8px', fontSize: '15px', whiteSpace: 'nowrap'}}>Search In Tags</label>
                                <RHFInputBox
                                    style={{height: '20px', marginBottom: '5px', border: '1px solid black'}}
                                    onChange={(event) => onTagSearchChanged(event.currentTarget.value)}
                                    name="projectTagSearch"
                                    register={register}
                                />
                            </div>
                            <div style={{textAlign: 'center'}}>
                                <Button className="tag-filter-button" style={{ border: '2px solid black'}} text="New Tag" onClick={handleNewTag} />
                            </div>
                                <hr/>
                            <div id={`tagListScrollingContainer`} onScroll={(event) => getScrollStatus(event.currentTarget)} className="search-panel" style={{ maxHeight: '52vh' }}>
                                <PagedItemList
                                    noContainer={true}
                                    resetLastPage={false}
                                    ResetStateCallback={resetTagsListPaging}
                                    dataOptions={tagsPagingDataOptions}
                                    GetPagedItemList={getTags}
                                    DisplayList={displayTagSearchResults}
                                    orderByColumn={tagsPagingDataOptions?.getOrderByProperty() !== undefined ?
                                        tagsPagingDataOptions?.getOrderByProperty() : Constants.SearchPanelQueryOrderByNameColumn}
                                    orderByDirection={tagsPagingDataOptions?.getOrderByDirection() !== undefined ?
                                        tagsPagingDataOptions?.getOrderByDirection() : Constants.SearchPanelTagListQueryOrderByDirection}
                                    startingPage={Constants.SearchPanelQueryStartingPage}
                                    rowsPerPage={Constants.SearchPanelTagListDefaultRowCount}
                                    totalRows={tags?.totalRecords !== undefined ? tags.totalRecords : 1}
                                />
                            </div>
                        <div>
                         {/*   <hr/>
                        <div style={{ width: '100%', padding: '1rem 1rem' }}>
                            <h3>Tracts</h3>
                            <h4>Filters:</h4>
                            <span>
                                <Checkbox label="By Tag" value={isTagFilterChecked} onChange={handleTractTagFilterChanged}/>
                            </span>
                        </div>
                        </div>
                            <hr/>
                        <div>
                        <div style={{ width: '100%', padding: '1rem 1rem' }}>
                            <h3>Townships</h3>
                            <h4>Filters:</h4>
                            <span>
                                <Checkbox label="By Tag" value={isTownshipTagFilterChecked} onChange={handleTownshipTagFilterChanged}/>
                            </span>
                                    </div>*/}
                        </div>
                            <hr/>
                        {/*<div>
                        <div style={{ width: '100%', padding: '1rem 1rem' }}>
                            <h3>Sections</h3>
                            <h4>Filters:</h4>
                            <span>
                                <Checkbox label="By Tag" value={isSectionTagFilterChecked} onChange={handleSectionTagFilterChanged}/>
                            </span>
                        </div>
                        </div>
                            <hr/>*/}
                    </div>
                </Panel>
            </div>
        </>
    );
};

export default SearchPanel;


// WEBPACK FOOTER //
// ./src/components/common/SearchPanel.tsx